import Home from './pages/Home.svelte'
import Settings from './pages/Settings.svelte'
import Search from './pages/Search.svelte'
import Result from './pages/Result.svelte'
import NearMeResult from './pages/NearMeResult.svelte'
import Detail from './pages/Detail.svelte'
import ChangePass from './pages/ChangePass.svelte'
import ChangeEmail from './pages/ChangeEmail.svelte'
import AddStation from './pages/AddStation.svelte'
import UpdateSation from './pages/UpdateStation.svelte'
import Logout from '../pages/Logout.svelte'


export const routes = [
    { name: 'home', path: '/' ,component:Home},
    { name: 'settings', path: '/settings', component:Settings},
    { name: 'search', path: '/search',component:Search },
    { name: 'list', path: '/list',component:Result },
    { name: 'nearme', path: '/nearme', component: NearMeResult },
    { name: 'detail', path: '/detail/:station_id', component: Detail },
    { name: 'change_pass', path: '/changepass', component: ChangePass},
    { name: 'change_email', path: '/changeemail', component: ChangeEmail },
    { name: 'add_station', path: '/addstation', component: AddStation},
    { name: 'update_station', path: '/updatestation/:station_id', component: UpdateSation},
    { name: 'logout' , path: '/logout', component:Logout} 

];
